import * as React from 'react';
import classnames from 'classnames';
import { ProductDetailReviewsView } from '@grandvisionhq/fun-products';
import { useFeatureToggles, useIntl } from '@grandvisionhq/state';
import { UserReviewsDisplay } from '../UserReviewsDisplay/UserReviewsDisplay.js';
import { useProductDetailContext } from '../../Context/ProductDetailContext.js';

const ProductDetailReviewsDrawerContainer = ({ className  })=>{
    const { isPdpDrawerLayoutEnabled  } = useFeatureToggles();
    const { product: { ratingsSummary  } ,  } = useProductDetailContext();
    const { getLabel  } = useIntl();
    const title = getLabel('reviews.drawer.button.title');
    // default review count to zero when we don't have any ratings available
    const { reviewCount =0  } = ratingsSummary !== null && ratingsSummary !== void 0 ? ratingsSummary : {};
    if (!isPdpDrawerLayoutEnabled || reviewCount === 0) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("section", {
        className: classnames('product-detail-reviews', className),
        "aria-label": title,
        "data-t": "product-detail-reviews"
    }, /*#__PURE__*/ React.createElement(ProductDetailReviewsView, {
        title: title
    }, /*#__PURE__*/ React.createElement(UserReviewsDisplay, {
        isSingleColumn: true
    })));
};

export { ProductDetailReviewsDrawerContainer };
//# sourceMappingURL=ProductDetailReviewsDrawerContainer.js.map
